import React from 'react'
import './App.css'
import './../ressurser/css/framework.css'
import './../ressurser/css/global.css'
import { connect } from 'react-redux'
import { Route, Routes } from 'react-router'

import {
    hentFeatureToggle,
    hentInformasjonstekst,
    hentKodeverk,
    hentTrineVedlikeholdBanner,
    hentTrineVedlikeholdTekst,
    setDatasett
} from '../actions'
import { ANTALL_PERSONSKADER } from '../ressurser/Konstanter'

import { selectAlert, selectOmStatistikkenValgt } from './appSelector'
import { Fot, Tilbakemelding } from './footer/FooterContainer'
import Header from './header/Header'
import VedlikeholdBanner from './header/VedlikeholdBanner'
import OmStatistikken from './infoomtrafikkulykkesregisteret/OmStatistikken'
import { LoggingAvPublikum } from './loggingavpublikum/LoggingAvPublikumContainer'
import Midtdel from './midtdel/Midtdel'
import { NavigasjonContainer } from './navigasjon/NavigasjonContainer'
import Nettstedskart from './nettstedskart/Nettstedskart'
import StandardrapporterSide from './standardrapporter/StandardrapporterSide'

class App extends React.Component {
    constructor(props) {
        super(props)
        const { setValgtData } = this.props
        setValgtData(ANTALL_PERSONSKADER)
    }

    componentDidMount() {
        this.props.getKodeverk()
        this.props.getFeatureToggle()
        this.props.hentInformasjonstekst()
        this.props.getBannerVedlikehold()
        this.props.getTekstVedlikehold()
    }

    render() {
        return (
            <div className="App">
                <LoggingAvPublikum />
                <Header />
                <VedlikeholdBanner />
                <main id="main">
                    <Routes>
                        <Route path="/om" element={<OmStatistikken />} />
                        <Route path="/nettstedskart" element={<Nettstedskart />} />
                        <Route path="/rapporter" element={<StandardrapporterSide />} />
                        <Route path="/" element={<Midtdel />} />
                    </Routes>
                    <Tilbakemelding />
                </main>
                <nav aria-label="navigasjon">
                    <NavigasjonContainer />
                </nav>
                <Fot />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    omStatistikkenValgt: selectOmStatistikkenValgt(state),
    alert: selectAlert(state)
})

const mapDispatchToProps = (dispatch) => ({
    getKodeverk: () => {
        dispatch(hentKodeverk())
    },
    getFeatureToggle: () => {
        dispatch(hentFeatureToggle())
    },
    getBannerVedlikehold: () => {
        dispatch(hentTrineVedlikeholdBanner())
    },
    getTekstVedlikehold: () => {
        dispatch(hentTrineVedlikeholdTekst())
    },
    setValgtData: (data) => {
        dispatch(setDatasett(data))
    },
    hentInformasjonstekst: () => {
        dispatch(hentInformasjonstekst())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
